import { AxiosError, isAxiosError } from 'axios';
import { z } from 'zod';
import { snack } from '~/hooks/ToastProvider';
import { JSONApiError, JSONApiErrorResponse } from '~/types/jsonapi';

export const firstJSONApiError = (val: JSONApiErrorResponse | AxiosError<JSONApiErrorResponse>) => {
  const data = isAxiosError<JSONApiErrorResponse>(val) ? val.response?.data : val;
  if (!data) return;
  return data.errors?.[0];
};

const JSONApiErrorResponseSchema = z.object({
  errors: z
    .array(
      z.object({
        code: z.string(),
        detail: z.string(),
        title: z.string(),
      }),
    )
    .min(1),
});

export function extractAxiosJSONApiErrors(error: unknown): JSONApiError[] | null {
  if (isAxiosError(error)) {
    const data = error.response?.data;
    const parseResult = JSONApiErrorResponseSchema.safeParse(data);
    if (parseResult.success) {
      return parseResult.data.errors;
    }
  }
  const parseResult = JSONApiErrorResponseSchema.safeParse(error);
  if (parseResult.success) {
    return parseResult.data.errors;
  }

  return null;
}

export function snackFirstJSONApiError(error: unknown, fallback: string) {
  const errors = extractAxiosJSONApiErrors(error);
  if (errors?.[0]) {
    snack.error(errors[0].detail);
  } else {
    snack.error(fallback);
  }
}
